import React, { useEffect, useState } from 'react';
import { AnnouncementBar } from '@screentone/core';

interface AnnouncementBarProps {
  id: string;
  content: string | React.ElementType;
}
function getLocalStorage(storageId: string) {
  try {
    return localStorage.getItem(storageId);
  } catch (error) {
    return null;
  }
}
const AnnouncementBarComponent: React.FC<AnnouncementBarProps> = ({ id, content }) => {
  const STORAGE_ID_DEFAULT = `st-announcement-${id}`;
  const storageItem = JSON.parse(getLocalStorage(STORAGE_ID_DEFAULT) || '{}');
  const [dismissed, setDismissed] = useState(storageItem.dismissed);

  useEffect(() => {
    function getStorage() {
      const item = JSON.parse(getLocalStorage(STORAGE_ID_DEFAULT) || '{}');
      if (item.dismissed !== dismissed) {
        setDismissed(item.dismissed)
      }
    }
    window.addEventListener('storage', getStorage);
    return () => {
      window.removeEventListener('storage', getStorage);
    }
  }, [])
  
  if (dismissed) {
    return null;
  }
  
  return (
    <AnnouncementBar
      onDismiss={() => {
        setDismissed(true);
        try {
          localStorage.setItem(STORAGE_ID_DEFAULT, JSON.stringify({ dismissed: true }));
        } catch (error) {
          console.log('error: ', error);
        }
      }}>
        {content}
    </AnnouncementBar>
  );
};

export default AnnouncementBarComponent;
export { AnnouncementBarComponent, AnnouncementBarProps};
